<div
    @refresh
    gaCategory="View Tutorial"
    class="tour"
    [class.tour--started]="tourStarted"
    [class.tour--ended]="tourEnded"
    role="dialog"
    aria-label="Getting Started Tutorial"
    cdkTrapFocus
    >

    <!-- intro slide -->
    <div class="tour__intro" *ngIf="!tourStarted">

        <h2 class="tour__title">Getting Started</h2>

        <p class="tour__welcome">
            Welcome! This tutorial will teach you how to navigate and explore in 3D using your 
            
            <button
                app-view-rounded-button
                buttonType="outline"
                icon="chevron-down"
                iconPlacement="right"
                [compact]="true"
                [label]="inputModesText[inputMode$ | async]"
                [attr.aria-label]="inputModesText[inputMode$ | async]"
                class="tour__input-selection text-small"
                [matMenuTriggerFor]="inputSelectionMenu">                
            </button>

            <mat-menu #inputSelectionMenu="matMenu">
                <button
                    gaEvent
                    gaAction="Clicked Input Type"
                    [gaLabel]="inputModesText[inputModes.Mouse]"
                    mat-menu-item
                    (click)="handleSelectInputModeClick(inputModes.Mouse)">
                    {{ inputModesText[inputModes.Mouse] }}
                </button>
                <button
                    gaEvent
                    gaAction="Clicked Input Type"
                    [gaLabel]="inputModesText[inputModes.Touch]"
                    mat-menu-item
                    (click)="handleSelectInputModeClick(inputModes.Touch)">
                    {{ inputModesText[inputModes.Touch] }}
                </button>
            </mat-menu>

        </p>                

        <div class="tour__footer">
            <button
                gaEvent
                gaAction="Clicked No Thanks"
                app-view-rounded-button 
                buttonType="outline"
                label="No, Thanks."
                class="mr-3 text-medium"
                (click)="handleExitClick()">
            </button>

            <button
                gaEvent
                gaAction="Clicked Start Tutorial"
                app-view-rounded-button
                buttonType="solid"
                label="Start Tutorial"
                aria-label="Start Tutorial"
                class="ml-3 text-medium"
                (click)="handleStartClick()">
            </button>

        </div>
    </div> 

    <!-- tour slides -->
    <div class="tour__contents" *ngIf="tourStarted" [ngSwitch]="inputMode$ | async">
        <app-view-tour-mobile *ngSwitchCase="inputModes.Touch"></app-view-tour-mobile>
        <app-view-tour-desktop *ngSwitchDefault></app-view-tour-desktop>            
    </div>
</div>